import React, { Component } from "react";

class Pagination extends Component {
    constructor(props) {
        // console.log(props);
        super(props);
        this.state = {
            current: props.current || 1,
        };
    }

    handlePreviou = (e) => {
        e.stopPropagation();
        const { current } = this.state;
        if (current > 1) {
            this.setState({ current: current - 1 });
            if (this.props.onChange) {
                this.props.onChange(current - 1);
            }
        }
    }

    handleNext = (e) => {
        e.stopPropagation();
        const { current } = this.state;
        const { total, pageSize } = this.props;
        const totalPages = Math.ceil(total / pageSize);
        if (current < totalPages) {
            this.setState({ current: current + 1 });
            if (this.props.onChange) {
                this.props.onChange(current + 1);
            }
        }
    }

    render() {
        const { total, pageSize } = this.props;
        const { current } = this.state;
        const totalPages = Math.ceil(total / pageSize);
        return (
            <div style={styles.container}>
                <div style={{ ...styles.arrow, opacity: current === 1 ? 0.4 : 1 }} onClick={this.handlePreviou}>{"<"}</div>
                <div style={styles.current}>{current}</div>
                <div style={styles.slash}>/</div>
                <div style={styles.totalPages}>{totalPages}</div>
                <div style={{ ...styles.arrow, opacity: current === totalPages ? 0.4 : 1 }} onClick={this.handleNext}>{">"}</div>
            </div>
        );
    }
}
const styles = {
    container: {
        height: "24px",
        fontSize: "14px",
        fontWeight: 400,
        color: "#FFFFFF",
        lineHeight: "22px",
        display: "flex",
    },
    arrow: {
        margin: "0 14px",
        cursor: "pointer",
    },
    slash: {
        margin: "0 16px",
    },
    current: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "48px",
        height: "22px",
        // color: "#5584FF",
        borderRadius: "2px",
        // background: "white",
        // border: " 1px solid rgba(0, 0, 0, 0.15)",
    },
    totalPages: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "48px",
        height: "22px",
    },

};

export default Pagination;



// WEBPACK FOOTER //
// ./src/AntD/pages/SelectCompany/Pagination.js